// extracted by mini-css-extract-plugin
module.exports = {"container":"_75ce47e7","textHeader":"_0cd38728","main":"_94d452dc","content":"_2b1f4808 bg-white br3"};